import React from 'react';
import SelectCard from '_lex/_atoms/SelectCard';
import { SolutionWithActive } from '../_types';
import { useManageSolutionsContext } from '../context';

type SolutionTabCardProps = {
  solution: SolutionWithActive;
  selected?: boolean;
  onSelect?: (solution: SolutionWithActive) => void;
};

const SolutionTabCard: React.FC<SolutionTabCardProps> = ({ solution, selected = false, onSelect }) => {
  const { getIcon } = useManageSolutionsContext();

  return (
    <SelectCard
      title={solution.name}
      icon={getIcon(solution.key)}
      selected={selected}
      statusLabel={solution.active ? 'Active' : 'Inactive'}
      statusColor={solution.active ? 'success' : 'default'}
      onClick={() => onSelect?.(solution)}
    />
  );
};

export default SolutionTabCard;
